import gql from 'graphql-tag';
import {
  AddressComponentOverride,
  AuditCheckboxComponentOverride,
  AuditTagComponentOverride,
  AuditTextComponentOverride,
  CombinedTagsComponentOverride,
  DateComponentOverride,
  DateRangeComponentOverride,
  EmailComponentOverride,
  EntityBatchComponentOverride,
  FileComponentOverride,
  GeolocationComponentOverride,
  InputButtonComponentOverride,
  NumberComponentOverride,
  PersonComponentOverride,
  ReferencedInComponentOverride,
  RelatedCardComponentOverride,
  RelatedCardLookupComponentOverride,
  ScheduledAutomationComponentOverride,
  SignatureComponentOverride,
  StaticTextComponentOverride,
  SubformComponentOverride,
  TagComponentOverride,
  TextComponentOverride,
  TimeTrackerComponentOverride,
  TodoComponentOverride,
  UrlComponentOverride,
} from './component';

export const FilterByComponent = gql`
  fragment FilterByComponent on FilterByComponentObject {
    componentId
    value {
      stringWildcard {
        value
      }
      containsNumber {
        values
        negate
      }
      containsString {
        values
        negate
      }
      dateIs {
        operator
        relativeDate {
          duration
          timeUnit
        }
      }
      dateRange {
        before
        after
      }
      dateTokenIs {
        value
      }
      numberIs {
        operator
        value
      }
      isEmpty {
        value
      }
      containsCurrentUser {
        value
      }
    }
  }
`;

export const ViewTemplate = gql`
  fragment ViewTemplate on ViewTemplate {
    id
    createdAt
    updatedAt
    name
    type
    subtype
    customSortingEnabled
    calendarDateComponentId
    checklistTagComponentId
    isPublic
    defaultHiddenComponents
    defaultHiddenLabels
    defaultReadonlyComponents
    displayInCards
    displayLegacyRecurrence
    displayLegacyReminders
    displayLegacyStatusButton
    displayMessageThread
    summarizeReadonlyTags
    sortOrder
    customSortingEnabled
    workflowTemplateId
    collectionCriteria {
      sortByComponents {
        componentId
        direction
      }
      filterByComponents {
        ...FilterByComponent
      }
      groups {
        filterByComponents {
          ...FilterByComponent
        }
      }
    }
    componentsViewOptions {
      componentId
      isHidden
      overrides {
        ...AddressComponentOverride
        ...AuditCheckboxComponentOverride
        ...AuditTagComponentOverride
        ...AuditTextComponentOverride
        ...CombinedTagsComponentOverride
        ...DateComponentOverride
        ...DateRangeComponentOverride
        ...EmailComponentOverride
        ...EntityBatchComponentOverride
        ...FileComponentOverride
        ...GeolocationComponentOverride
        ...InputButtonComponentOverride
        ...NumberComponentOverride
        ...PersonComponentOverride
        ...RelatedCardComponentOverride
        ...RelatedCardLookupComponentOverride
        ...ReferencedInComponentOverride
        ...ScheduledAutomationComponentOverride
        ...SignatureComponentOverride
        ...StaticTextComponentOverride
        ...SubformComponentOverride
        ...TagComponentOverride
        ...TextComponentOverride
        ...TodoComponentOverride
        ...TimeTrackerComponentOverride
        ...UrlComponentOverride
      }
    }
  }
  ${FilterByComponent}
  ${AddressComponentOverride}
  ${AuditCheckboxComponentOverride}
  ${AuditTagComponentOverride}
  ${AuditTextComponentOverride}
  ${CombinedTagsComponentOverride}
  ${DateComponentOverride}
  ${DateRangeComponentOverride}
  ${EmailComponentOverride}
  ${EntityBatchComponentOverride}
  ${FileComponentOverride}
  ${GeolocationComponentOverride}
  ${InputButtonComponentOverride}
  ${NumberComponentOverride}
  ${PersonComponentOverride}
  ${RelatedCardComponentOverride}
  ${RelatedCardLookupComponentOverride}
  ${ReferencedInComponentOverride}
  ${ScheduledAutomationComponentOverride}
  ${SignatureComponentOverride}
  ${StaticTextComponentOverride}
  ${SubformComponentOverride}
  ${TagComponentOverride}
  ${TextComponentOverride}
  ${TodoComponentOverride}
  ${TimeTrackerComponentOverride}
  ${UrlComponentOverride}
`;

export const ViewTemplateLayoutSection = gql`
  fragment ViewTemplateLayoutSection on ViewTemplateLayoutSection {
    id
    type
    title
    isCollapsed
    componentIds
    columnCount
  }
`;

export const ViewTemplateLayoutComponent = gql`
  fragment ViewTemplateLayoutComponent on ViewTemplateLayoutComponent {
    id
    type
    componentId
  }
`;

export const ViewTemplateLayout = gql`
  fragment ViewTemplateLayout on ViewTemplateLayout {
    id
    items {
      ... on ViewTemplateLayoutSection {
        ...ViewTemplateLayoutSection
      }
      ... on ViewTemplateLayoutComponent {
        ...ViewTemplateLayoutComponent
      }
    }
  }
  ${ViewTemplateLayoutSection}
  ${ViewTemplateLayoutComponent}
`;
